import { TargetAttackGameOver } from './TargetAttackGameOver.tsx';
import { TargetAttackHud } from './TargetAttackHud.tsx';
import { TargetAttackPause } from './TargetAttackPause.tsx';

/** Входной адаптер (in): DOM-HUD для target-attack; скелет и мишени — в `CanvasRenderer`. */
export function TargetAttackTvOverlays() {
  return (
    <>
      <TargetAttackHud />
      <TargetAttackPause />
      <TargetAttackGameOver />
    </>
  );
}
